import { useTheme } from "../../contexts/useTheme";
import { useUpdateUserConfig } from "../user/useUpdateUserConfig";

export const useThemeToggle = () => {
  const { currentTheme, setTheme } = useTheme();
  const { updateUserConfig } = useUpdateUserConfig();

  const isDarkMode = !currentTheme.startsWith("light_");

  const toggleTheme = async () => {
    const target = isDarkMode ? "light_yellow" : "dark_yellow";
    setTheme(target);
    await updateUserConfig({ theme: target });
  };

  return { isDarkMode, toggleTheme };
};
